import { Actions } from './actions';
import { CLEAR_WEIGTH_STATE, GET_WEIGHT_ERROR, GET_WEIGHT_REQUEST, GET_WEIGHT_SUCCESS } from './constants';

const initialState = {
  loading: false,
  error: null as Error | null,

  fieldName: '' as string,
  weight: '' as string,
};

export type WeightScalesState = typeof initialState;

export const weightScalesReducer = (state: WeightScalesState = initialState, action: Actions) => {
  switch (action.type) {
    case GET_WEIGHT_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null,
        fieldName: action.fieldName,
      };
    }
    case GET_WEIGHT_SUCCESS: {
      return {
        ...state,
        loading: false,
        errorMsg: null,
        weight: action.payload,
      };
    }
    case GET_WEIGHT_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload,
        weight: null,
      };
    }
    case CLEAR_WEIGTH_STATE: {
      return {
        ...state,
        loading: false,
        error: null,
        weight: null,
        fieldName: '',
      };
    }
    default: {
      return state;
    }
  }
};
